import { render, staticRenderFns } from "./WhatIsProjectStep.vue?vue&type=template&id=ea451a72"
import script from "./WhatIsProjectStep.vue?vue&type=script&lang=js"
export * from "./WhatIsProjectStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports